import { styled, css } from '@styledComponents';

/**
 * CSS mixin for dotted underline link style.
 * Default state: dotted underline
 * Hover state: solid underline
 *
 * Use this mixin to apply the dotted link style to any styled component.
 */
export const dottedLinkStyles = css`
  text-decoration: underline;
  text-decoration-style: dotted;
  text-decoration-thickness: 1px;
  text-underline-offset: 5px;
  cursor: pointer;

  &:hover {
    text-decoration-style: solid;
  }
`;

/**
 * A reusable link style with dotted underline by default, solid on hover.
 * Use for promotional CTAs, "Learn More" links, and similar secondary links.
 *
 * @example
 * // As a standalone element
 * <DottedLink>Explore Designs</DottedLink>
 *
 * @example
 * // Extending with additional styles
 * const CustomLink = styled(DottedLink)`
 *   color: ${themeColor('mono1')};
 *   margin-top: ${themeSpace(4)};
 * `;
 */
export const DottedLink = styled.span`
  ${dottedLinkStyles}
`;
